import { render } from "./PayslipItemsTable.vue?vue&type=template&id=0d4c4b2c&scoped=true"
import script from "./PayslipItemsTable.vue?vue&type=script&lang=js"
export * from "./PayslipItemsTable.vue?vue&type=script&lang=js"

import "./PayslipItemsTable.vue?vue&type=style&index=0&id=0d4c4b2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d4c4b2c"]])

export default __exports__